import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Pseudo-classes/nth-of-type";
import * as React from 'react';
export default {
  Content,
  React
};